const loadScript = (
  src: string,
  onLoad: (this: HTMLScriptElement, ev: Event) => void,
  onError: (this: HTMLScriptElement, ev: ErrorEvent) => void
): void => {
  const scriptElem = document.createElement('script');
  scriptElem.src = src;

  scriptElem.addEventListener('load', onLoad);
  scriptElem.addEventListener('error', onError);
  document.head.appendChild(scriptElem);
};

export default loadScript;
